import { ref, computed } from 'vue';
/**
 * Combo menus (distinct from useMenu = product listing).
 */
export function useMenus(getMenusFromBundle) {
    const menus = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const loadMenus = async (fetchFn) => {
        if (getMenusFromBundle) {
            menus.value = getMenusFromBundle() || [];
            return;
        }
        if (!fetchFn)
            return;
        loading.value = true;
        error.value = null;
        try {
            menus.value = await fetchFn();
        }
        catch (e) {
            error.value = e?.message || 'Menüs konnten nicht geladen werden';
            menus.value = [];
        }
        finally {
            loading.value = false;
        }
    };
    const activeMenus = computed(() => menus.value.filter((m) => m.menuPriceCent > 0));
    const calculateMenuSavings = (menu) => {
        if (menu.referenceSavingsCent && menu.referenceSavingsCent > 0) {
            return menu.referenceSavingsCent;
        }
        return 0;
    };
    return {
        menus,
        activeMenus,
        loading,
        error,
        loadMenus,
        calculateMenuSavings
    };
}
